export default {"src":"/_next/static/media/droppedPin.3298b275.svg","height":12,"width":10};